import PropTypes from 'prop-types';
import React from 'react';
import CreateAccountForm from './create-form';

// General Create Account Form Wrapper with heading
const CreateAccount = props => (
  <div className='CreateAccount contentPage'>
    <div className='content'>
      <h2 className='h2'>{props.pageStrings['create-account-form-header']}</h2>
      <CreateAccountForm {...props} />
    </div>
  </div>
);

CreateAccount.propTypes = {
  success: PropTypes.bool,
  userAlreadyExistsError: PropTypes.bool,
  unacceptableEmailError: PropTypes.bool,
  genericError: PropTypes.bool,
  pageStrings: PropTypes.shape({
    'create-account-form-header': PropTypes.string.isRequired,
  }).isRequired,
};

CreateAccount.defaultProps = {
  success: false,
  userAlreadyExistsError: false,
  unacceptableEmailError: false,
  genericError: false,
};

export default CreateAccount;



// WEBPACK FOOTER //
// ./app/components/account/create.jsx